import React from 'react';
import { get } from 'lodash';
import { withRouter } from 'react-router-dom';

// React view component to render
import { offCallControlWidget as OffCallControlWidgetView } from 'ui/views/widgets/offCallControlWidget';
import { OffCallControlWidgetService } from 'services/offCallControlWidget';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { DASHBOARD_SUB_ROUTES } from 'constants/route-paths';

// import * as backRoute from 'utils/backRoute';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { OffCallControlWidget } from 'ui/containers/OffCallControlWidget';
 *
 * // render
 * <OffCallControlWidget propName='propValue'/>
 */
class _OffCallControlWidget extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
		super( props );
        
        // component state
		this.state = {
			isFetching: true,
			networkStatus: undefined,
			componentData: undefined,
		};

		// create service instance
		this.offCallControlWidgetService = new OffCallControlWidgetService();

		// start component data fetch
		this.fetchComponentData();
    }

    /*********************************************/

	/**
	 * @desc Fetch component response.
	 */
	async fetchComponentData() {
		log.debug( 'OffCallControlWidget.fetchComponentData()' );
        const memberId = get( this.props.location, 'state.memberId', undefined );

		//Added PatientId
		const patientId = get( this.props.location, 'state.patientId', undefined );

		// cancel ongoing request
		this.offCallControlWidgetService.cancel();

		// fetch component data
		const {
			status,
			data,
		} = await this.offCallControlWidgetService.fetchComponentData( {
			url: this.props.widget.url,
			data: {
				context: {
					memberId: memberId,
					patientId: patientId
				},
				data: {},
			},
        } );
        
        this.handleNavActionClick = this.handleNavActionClick.bind( this );

		// check if response status was success
		if ( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
			this.setState( {
				isFetching: false,
				networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
			} );
		} else {
			this.setState( {
				isFetching: false,
				networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
				componentData: data,
			} );
		}
    }

    handleNavActionClick( { type, value } ) {
        log.debug( 'OffCallControlWidget.handleNavActionClick()' );

        if( 'headerAction' === type && 'back' === value.name ) {

			this.props.history.push( DASHBOARD_SUB_ROUTES.CALL_MANAGEMENT_LISTS );


            // get back-route payload
            // const backRoutePayload = backRoute.decode( this.props.location );

            // if( ! isEmpty( backRoutePayload ) ) {
            //     return this.props.history.push( backRoutePayload );
            // }

            // this.props.history.goBack();
        }
    }
    
    /**
	 * @desc When component unmounts, cleanup resouces.
	 */
	componentWillUnmount() {
		this.offCallControlWidgetService.cancel(); // cancel ongoing requests
	}

    /**
     * @desc Render a React view component
     */
    render() {

		// getting the member Id
		const memberId = get( this.props.location, 'state.memberId', undefined );
		const patientId = get( this.props.location, 'state.patientId', undefined );
		
        return (
            <OffCallControlWidgetView
                {...get( this.state, 'componentData', {} ) }
                isFetching={this.state.isFetching}
                networkStatus={this.state.networkStatus}
				onNavActionClick={ this.handleNavActionClick }
				memberId={ memberId }
				patientId={ patientId }
            />
        );
    }
}

// set display name
_OffCallControlWidget.displayName = 'OffCallControlWidget';

// set default props
_OffCallControlWidget.defaultProps = {};

// prop types
_OffCallControlWidget.propTypes = {};

export const OffCallControlWidget = withRouter( _OffCallControlWidget );
